import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import store from '@/store';
import iView from 'view-design';
import i18n from '@/i18n' // 引入i8n实例
import {
    getQuery,
    getStore,
    replaceParamVal
} from '@/utils';

Vue.use(Router);
const router = new Router({
    mode: 'history',
    base: '/tourdesign/',
    routes
});
let href = ''
router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    const ua = window.navigator.userAgent
    var isIE = ua.indexOf("compatible") > -1 && ua.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    let isEdge = ua.indexOf("Edge") > -1
    if (isIE && !isEdge) {
        alert("您正在使用的浏览器版本过低，为了您的最佳体验，请先升级浏览器。");
        window.location.href = "http://support.dmeng.net/upgrade-your-browser.html?referrer=" + encodeURIComponent(window.location.href);
    } else {
        const tokenId = getQuery("tokenId");
        const accessToken = getStore({
            name: "access_token",
            type: 'session'
        });
        if (tokenId !== accessToken) {
            store.dispatch('setPageLoading', true);
        } else {
            store.dispatch('setPageLoading', false);
        }
        // 如果地址栏带有tokenId，会校验tokenId合法性
        if (tokenId) {
            // 如果是设计软件内嵌页面，且地址栏带有tokenId，校验token的时候，接口header不传内容
            // 如果是前台页面，且地址栏带有tokenId，校验token的时候，接口header 传Authorization: Basic YmJzOmJicw==
            const params = {
                tokenId: tokenId,
                isCaxa: true
            }
            store.dispatch('handleCheckToken', params).then((res) => {
                i18n.locale = res.data.data.lan || 'zh-CN'
                next()
            }).catch(() => {
                next()
            })
            return false
        } else {
            next();
        }
    }
});

router.afterEach(to => {
    iView.LoadingBar.finish();
    // const tokenId = getQuery("tokenId");
    // const accessToken = getStore({
    //     name: "access_token",
    //     type: 'session'
    // });
    // if (accessToken !== undefined && tokenId !== undefined && tokenId && accessToken) {
    //     let href = replaceParamVal(location.href, "tokenId", accessToken);
    //     if (tokenId !== accessToken) {
    //         location.replace(href);
    //     }
    // }
    window.scrollTo(0, 0);
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js